import React, { PureComponent, Fragment } from 'react'
import { Route } from 'react-router-dom'
import Employees from '../Employees'
import AddEmployee from '../Employees/AddEmployee'
import InvitedEmployees from './InvitedEmployees'
import TimeCards from './TimeCards'
import InviteEmployeeForm from '../../../components/Employees/InviteEmployeeForm'

export default class ManageEmployees extends PureComponent {
  render() {
    const { match } = this.props
    return (
      <Fragment>
        <Route exact path={`${match.url}/clocked_in`} component={Employees} />
        <Route exact path={`${match.url}/employees/`} component={Employees} />
        <Route exact path={`${match.url}/employees/add`} component={AddEmployee} />
        <Route exact path={`${match.url}/employees/:id/edit`} component={AddEmployee} />
        <Route exact path={`${match.url}/invitedemployees`} component={InvitedEmployees} />
        <Route exact path={`${match.url}/inviteemployee`} component={InviteEmployeeForm} />
        <Route exact path={`${match.url}/timecards`} component={TimeCards} />
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Employees/ManageEmployees.js